<template>

  <div class="row">

    <div class=" col-lg-2 col-md-3 col-sm-12">
      <!-- Profile Image -->
      <div class="card card-info card-outline">
        <div class="card-body box-profile">
          <div class="text-center">
            <img style="width: 175px;" class="profile-user-img img-fluid img-circle" :src="img" alt="User profile picture">
          </div>
        </div>
        <!-- /.card-body -->
      </div>
      <!-- /.card -->
    </div>

    <div class=" col-lg-10 col-md-9 col-sm-12">
      <div class="card">
        <form id="profile" v-on:submit="save">
          <div class="card-header">
            <h1 class="card-title" style="font-size: 20px; font-weight: bold ">Student Profile</h1>
          </div>

          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <h6 class="h4-t">Admission Information</h6>
                <hr />
              </div>

              <div class=" col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Program *</label>
                  <select class="form-control form-control-sm" required v-model="st.ProgramID">
                    <option value="" selected="selected" disabled="disabled">--Select--</option>
                    <option v-for="item in programs" v-bind:value="item.ProgramID">{{ item.ProgramName }}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Session *</label>
                  <select class="form-control form-control-sm" required v-model="st.SessionID">
                    <option value="" selected="selected" disabled="disabled">--Select--</option>
                    <option v-for="item in sessions" :value="item.SessionID"> {{ item.Name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Roll No *</label>
                  <input class="form-control form-control-sm" id="name" v-model="st.RollNo" maxlength="20" required />
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Registration No *</label>
                  <select class="form-control" v-model="st.RegistrationNoStatus" v-on:change="regChange()" required>
                    <option value="" selected disabled>--Select Option--</option>
                    <option value="Yes">Yes</option>
                    <option value="AppliedFor">Applied For</option>
                  </select>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12" v-if="RegShow == 'show'">
                <div class="form-group">
                  <label>Registration No *</label>
                  <input class="form-control form-control-sm" id="name" v-model="st.RegistrationNo" maxlength="20" required />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <h6 class="h4-c">Personal Information</h6>
                <hr />
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Name *</label>
                  <input class="form-control form-control-sm" id="name" v-model="st.Name" v-on:keypress="isLetter($event)" required />
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Father Name *</label>
                  <input maxlength="60" v-model="st.FatherName" class="form-control" v-on:keypress="isLetter($event)" required />
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>CNIC *</label>
                  <input class="form-control" type="text" v-mask="'#####-#######-#'" v-model="st.CNIC" maxlength="15" minlength="15" required title="15 characters required with dashes" pattern="{15}">
                </div>
              </div>

              <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>Date of Birth *</label>
                  <input type="date" id="DOB" placeholder="dd-MMM-yyyy" required v-model="st.DateOfBirth" class="form-control" />
                </div>
              </div>

              <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>Gender *</label>
                  <select class="form-control" required id="ddlGeder" v-model="st.Gender">
                    <option value="" selected="selected" disabled="disabled">--Select--</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
              </div>

              <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="form-group">
                  <label>Merital Status *</label>
                  <select class="form-control" required v-model="st.MeritalStatus">
                    <option value="" selected="selected" disabled="disabled">--Select--</option>
                    <option value="Unmarried">Unmarried</option>
                    <option value="Married">Married</option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label>Image *</label>
                  <div>
                    <input type="file" id="profileimg" v-on:change="onfileupload">
                  </div>
                  <small>Max size is 1 mb <span style="color:red">(Passport Size, Front facing, White background)</span></small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <h6 class="h4-c">Other Information</h6>
                <hr />
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Address *</label>
                  <input class="form-control form-control-sm" id="name" v-model="st.Address" required />
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>District *</label>
                  <input class="form-control form-control-sm" id="name" v-model="st.District" required />
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Tehsil *</label>
                  <input class="form-control form-control-sm" id="name" v-model="st.Tehsil" required />
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>City/ Village *</label>
                  <input class="form-control form-control-sm" id="name" v-model="st.City" required />
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Email *</label>
                  <input type="email" class="form-control form-control-sm" id="name" v-model="st.Email" required />
                </div>
              </div>

              <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>Mobile No *</label>
                  <input class="form-control form-control-sm" id="name" v-model="st.MobileNo" v-mask="'###########'" required />
                </div>
              </div>

              <div class="col-lg-4 col-md-3 col-sm-6">
                <div class="form-group">
                  <label>Blood Group</label>
                  <select class="form-control" v-model="st.BloodGroup">
                    <option value="">--Select--</option>
                    <option value="A">A</option>
                    <option value="A+">A+</option>
                    <option value="A-">A-</option>
                    <option value="B">B</option>
                    <option value="B+">B+</option>
                    <option value="B-">B-</option>
                    <option value="O">O</option>
                    <option value="O+">O+</option>
                    <option value="O-">O-</option>
                    <option value="AB+">AB+</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Disability</label>
                  <select class="form-control" v-model="st.Disability">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Resident Of LOC</label>
                  <select class="form-control" v-model="st.ResidentOfLOC">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Verified</label>
                  <select class="form-control" v-model="st.Verified">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="float-right">
              <input type="button" value="Clear" class="btn btn-danger  " v-on:click="clear()" />
              <input type="submit" value="Save" class="btn btn-success  " />
            </div>
          </div>
        </form>

      </div>
      <!-- /.card -->
    </div>

    <div id="myModal" class="modal fade" role="dialog">
      <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Confirmation</h4>
          </div>
          <div class="modal-body">
            <p>Are you sure you want to save?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-success" data-dismiss="modal">Save</button>
          </div>
        </div>

      </div>
    </div>

  </div>


</template>

<script>
  const axios = require('axios').default;

  export default ({
    props: {
      employeeId: Number,
      sendEmp: Function,
      sendImg: Function,
    },
    data() {
      return {
        programs: [],
        sessions: [],
        st: {
          ProgramID: '',
          SessionID: '',
          Name: '',
          FatherName: '',
          RollNo: '',
          RegistrationNo: '',
          RegistrationNoStatus: '',
          DateOfBirth: '',
          Address: '',
          District: '',
          Tehsil: '',
          City: '',
          MeritalStatus: '',
          BloodGroup: '',
          CNIC: '',
          MobileNo: '',
          Disability: '',
          DisabilityReason: '',
          ResidentOfLOC: ''
        },
        Reg: '',
        RegShow: 'hide',
        img: '/dist/icon-profile.png'
      }
    },

    created: function () {
      this.pageLoad();
    },

    methods: {
      pageLoad() {
        startReq();
        var vm = this;
        axios.get('/api/StudentCardPrintingApi/pageLoadStudentEdit')
          .then(function (res) {
            endReq();
            vm.programs = res.data.programs;
            vm.sessions = res.data.sessions;
            vm.st = res.data.lst;
            vm.img = res.data.img;
            if (vm.st.RegistrationNoStatus == "Yes") {
              vm.RegShow = 'show';
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },

      regChange() {
        if (this.st.RegistrationNoStatus == "Yes") {
          this.RegShow = 'show';
          this.st.RegistrationNo = ''
        }
        else {
          this.RegShow = 'hide';
          this.st.RegistrationNo = 'Applied For'
        }
      },

      save(e) {
        e.preventDefault();
        var vm = this;

        if (vm.st.CNIC.length != 15) {
          alert("15 character required with dashes for CNIC");
          return;
        }
        else if (vm.st.MobileNo.length != 11) {
          alert("11 digits required for Mobile No");
          return;
        }
        else if (vm.img == '/dist/icon-profile.png' || !vm.img) {
          alert("Image is required");
          return;
        }

        startReq();
        axios.post('/api/StudentCardPrintingApi/UpdateProfile', {
          st: vm.st,
          img: vm.img,
        })
          .then(function (res) {
            endReq();
            if (res.data.status) {
              alert("Saved Successfully");
              window.location.href = "/StudentCardPrint/Index";
            }
            else {
              toastr.error(res.data.msg);
            }

          }).catch(function (err) {
            endReq();
          })
      },

      checkFile(file) {
        if (file == null) {
          return false;
        }

        if (file.size > 1000000) {
          toastr.error("file size is large maximum 1 mb allowed", "Error!");

          return false;
        }

        if (file.type != "image/jpeg" && file.type != "image/png") {
          toastr.error("Invalid File! only JPG and PNG is allowed");
          return false;
        }

        return true;
      },

      onfileupload: function (event) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var image = new Image;
          var reader = new FileReader;
          reader.onload = (e) => {
            this.img = e.target.result
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
        else {
          $('#profileimg').val('');
        }
      },

      isLetter(evt) {
        var charCode = (evt.which) ? evt.which : event.keyCode
        if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode == 32)
          return;
        event.preventDefault();
      },

      clear() {
        window.location.href = "/StudentCardPrint/Index";
      }

    }
  })</script>

<style>
  .h4-t {
    margin-top: -9px;
    margin-bottom: -5px;
    font-weight: 600
  }

  .h4-c {
    margin-bottom: -5px;
    font-weight: 600
  }
</style>





// WEBPACK FOOTER //
// src/components/cardprinting/studentCardPrintEdit.vue